import { dispatch } from 'store';
import { ProductType } from 'types/product.types';

import { myShopPageActions } from '../reducers/my-shop-page.reducer';

export const setMyShopAvailableProducts = (products: ProductType[], total: number) =>
  dispatch(myShopPageActions.setAvailableProducts({ products, total }));

export const setMyShopOtherProducts = (products: ProductType[], total: number) =>
  dispatch(myShopPageActions.setOtherProducts({ products, total }));

export const markProductDeleted = (productId: string) => dispatch(myShopPageActions.markProductDeleted({ productId }));

export const updateProductInMyShop = (product: ProductType) => dispatch(myShopPageActions.updateProduct({ product }));

export const addProductToMyShop = (product: ProductType) => dispatch(myShopPageActions.addProduct({ product }));

export const moveProductToOtherStatuses = (product: ProductType) => dispatch(myShopPageActions.moveProductToOtherStatuses({ product }));

export const moveProductToAvailable = (product: ProductType) => dispatch(myShopPageActions.moveProductToAvailable({ product }));

export const resetMyShopPage = () => dispatch(myShopPageActions.reset());
